export const translateMessage = (message) => {
  switch (message) {
    case 'Network Error':
      return 'Verifique sua conexão com a internet';
    default:
      return message;
  }
};
